import { CONFIGS } from "CONFIGS";
import { mockOrFetch } from "../../../../utils";
// eslint-disable-next-line jest/no-mocks-import
import mockData from "../../../../../__mocks__/flights-to.json";
import { BRANDS } from "../../../../configs";

const getDestinations = (lang, gateway, type, alias, brand, searchkey) => {
	let flightsDestinationsAPI = (type === "RE"
		? CONFIGS.FLIGHTS.DESTINATIONS
		: CONFIGS.FLIGHTS.ONE_WAY_DESTINATIONS
	)
		.replace("{lang}", lang)
		.replace("{gateways}", gateway)
		.replace("{alias}", alias);

	if (brand?.toLowerCase() === BRANDS.SOV.toLowerCase()) {
		flightsDestinationsAPI = CONFIGS.FLIGHTS_SOV.GATEWAYS.replace("{searchkey}", searchkey);
	}

	return mockOrFetch({ apiUrl: flightsDestinationsAPI, mockData });
};

export default getDestinations;
